import { render, staticRenderFns } from "./abnormalAccount.vue?vue&type=template&id=316f0ff9&scoped=true&"
import script from "./abnormalAccount.vue?vue&type=script&lang=js&"
export * from "./abnormalAccount.vue?vue&type=script&lang=js&"
import style0 from "./abnormalAccount.vue?vue&type=style&index=0&id=316f0ff9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "316f0ff9",
  null
  
)

export default component.exports